<template>
    <div>
      <!-- 面包屑导航区域 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>管理</el-breadcrumb-item>
        <el-breadcrumb-item>经销商对账列表</el-breadcrumb-item>
      </el-breadcrumb>
  
      <el-card>
        <!-- 订单列表数据 -->
        <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column type="index"></el-table-column>
          <el-table-column label="开始日期" prop="s_time" width="180px"></el-table-column>
          <el-table-column label="结束日期" prop="e_time" width="180px"></el-table-column>
          <el-table-column label="月初余额" prop="smoney" align="center" width="80px"> </el-table-column>
          <el-table-column label="月末余额" prop="enmoney" align="center" width="80px"> </el-table-column>
          <el-table-column label="月初授信" prop="screditMoney" align="center" width="80px"> </el-table-column>
          <el-table-column label="月末授信" prop="encreditMoney" align="center" width="80px"> </el-table-column>
          <el-table-column label="月初返点" prop="srefund" align="center" width="80px"> </el-table-column>
          <el-table-column label="月末返点" prop="enrefund" align="center" width="80px"> </el-table-column>
          <el-table-column label="月初设备补贴" prop="ssubsidy" align="center" width="80px"> </el-table-column>
          <el-table-column label="月末设备补贴" prop="ensubsidy" align="center" width="80px"> </el-table-column>
          <el-table-column label="是否对账" prop="ifac" align="center" width="80px"> </el-table-column>
          <el-table-column label="备注" prop="remark" align="center" width="180px"> </el-table-column>
          <!-- <el-table-column label="操作" width="250px" v-if="canLook == 1">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="editOrder(scope.row)">详情</el-button>
            </template>
          </el-table-column> -->
        </el-table>
  
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[10, 30, 50]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-card>
    </div>
  </template>
  
  <script>
  
  export default {
    props:['valueId'],
    data () {
      return {
        canLook: 1,
        uuid:'',
        exportUrl: 'javascript:return false;',
        queryInfo: {
          query: '',
          status: -1,
          type: 0,
          pagenum: 1,
          pagesize: 10,
          uuid:'',
        },
        statusValue: '全部',
        // 审核状态0未审核，1审核通过2拒绝
        statusOptions: [
          { value: '全部', id: -1 },
          { value: '未审核', id: 0 },
          { value: '审核通过', id: 1 },
          { value: '拒绝', id: 2 },
        ],
        typeValue: '全部',
        typeOptions: [
          { value: '全部', id: 0 },
          { value: '常温', id: 1 },
          { value: '低温', id: 2 },
        ],
        total: 0,
        orderlist: [],
        editDialogVisible: false,
        editForm: {
          creditMoney: null,
          refund: null,
          subsidy: null,
          remarkl: null,
        },
        editFormRules: {
          creditMoney: [
            { required: true, message: '请输入授信额度', trigger: 'blur' },
          ],
        },
        selectId: null,
        multipleSelectionjson: null,
      }
    },
    watch:{
      valueId(v){
        this.queryInfo.uuid = this.valueId;
        this.getOrderList();
      }
    },
    created () {
      // alert(323232)
      if (this.valueId) {//编辑
         this.queryInfo.uuid = this.valueId;
        // this.show = this.$route.query.show;
        this.$nextTick(()=>{
          this.getOrderList();
        })
        
      }
    },
    mounted(){
        // alert(666)
      // if (this.valueId) {//编辑
      //    this.queryInfo.uuid = this.valueId;
      //   // this.show = this.$route.query.show;
      //   this.getOrderList();
      // }
  },
    methods: {
      searchOrder () {
        this.total = 0
        this.orderlist = []
        this.getOrderList()
      },
  
      editDialogClosed () {
        this.$refs.editFormRef.resetFields()
      },
      filterSelect () {
        this.total = 0
        this.orderlist = []
        this.getOrderList()
      },
  
      async getOrderList () {
        const { data: res } = await this.$http.post('admin/Accountchecking/getacclist', {
          params: this.queryInfo
        })
        if (res.code !== 200) {
          return this.$message.error('获取列表失败！')
        }
        console.log(res)
        this.total = res.result.count
        this.orderlist = res.result.list
        if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
          this.canLook = 2
        }
      },
  
      handleSizeChange (newSize) {
        this.queryInfo.pagesize = newSize
        this.getOrderList()
      },
  
      handleCurrentChange (newPage) {
        this.queryInfo.pagenum = newPage
        this.getOrderList()
      },
  
    }
  }
  </script>
  
  <style lang="less" scoped>
  .el-table .cell {
    white-space: pre-line;
  }
  .el-row {
    margin-top: 10px;
  }
  
  .daiqueren {
    background-color: aquamarine;
  }
  
  .daifahuo {
    background-color: rgb(242, 255, 127);
  }
  .yifahuo {
    background-color: rgb(8, 27, 133);
  }
  
  .aaaa {
    margin-left: 10px;
  }
  </style>
  